export default "__VITE_ASSET__CRyotgep__"